import { 
  collection,
  getDocs,
  query,
  where
} from 'firebase/firestore';
import { db } from '../firebase';
import { getAllProducts } from './productService';
import { getAllCampaigns } from './discountService';
import { getAllOrders } from './orderService';
import { getAllCustomers } from './customerService';

// ==================== KOLEKSİYONLAR ====================
const ordersCollection = collection(db, 'Orders');

// ==================== ANALİTİK ====================

export const getAnalytics = async () => {
  try {
    const productsResult = await getAllProducts();
    const campaignsResult = await getAllCampaigns();
    const ordersResult = await getAllOrders();
    const customersResult = await getAllCustomers();
    
    if (!productsResult.success || !campaignsResult.success) {
      return { success: false, error: 'İstatistikler yüklenemedi' };
    }
    
    const products = productsResult.products;
    const campaigns = campaignsResult.campaigns;
    const orders = ordersResult.orders || [];
    const customers = customersResult.customers || [];
    
    // Bugün
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    // Bu ay
    const thisMonth = new Date();
    thisMonth.setDate(1);
    thisMonth.setHours(0, 0, 0, 0);
    
    const todayOrders = orders.filter(o => {
      const orderDate = new Date(o.createdAt);
      return orderDate >= today;
    });
    
    const monthOrders = orders.filter(o => {
      const orderDate = new Date(o.createdAt);
      return orderDate >= thisMonth;
    });
    
    const analytics = {
      // Ürün istatistikleri
      totalProducts: products.length,
      activeProducts: products.filter(p => p.isActive).length,
      totalRevenue: products.reduce((sum, p) => sum + (p.currentPrice * p.stock), 0),
      totalStock: products.reduce((sum, p) => sum + p.stock, 0),
      lowStockProducts: products.filter(p => p.stock < (p.minStock || 5)).length,
      discountedProducts: products.filter(p => p.discount > 0).length,
      totalSales: products.reduce((sum, p) => sum + (p.sales || 0), 0),
      averageDiscount: products
        .filter(p => p.discount > 0)
        .reduce((sum, p) => sum + p.discount, 0) / products.filter(p => p.discount > 0).length || 0,
      
      // Kampanya istatistikleri
      activeCampaigns: campaigns.filter(c => new Date(c.endDate) > new Date()).length,
      
      // Sipariş istatistikleri
      totalOrders: orders.length,
      pendingOrders: orders.filter(o => o.status === 'pending').length,
      processingOrders: orders.filter(o => o.status === 'processing').length,
      shippedOrders: orders.filter(o => o.status === 'shipped').length,
      completedOrders: orders.filter(o => o.status === 'delivered').length,
      cancelledOrders: orders.filter(o => o.status === 'cancelled').length,
      
      todayOrders: todayOrders.length,
      todayRevenue: todayOrders
        .filter(o => o.status !== 'cancelled')
        .reduce((sum, o) => sum + (o.total || 0), 0),
      
      monthlyOrders: monthOrders.length,
      monthlyRevenue: monthOrders
        .filter(o => o.status !== 'cancelled')
        .reduce((sum, o) => sum + (o.total || 0), 0),
      
      // Müşteri istatistikleri
      totalCustomers: customers.length,
      activeCustomers: customers.filter(c => c.status === 'active').length,
      vipCustomers: customers.filter(c => (c.totalOrders || 0) >= 10).length,
      
      // Finansal istatistikler
      totalSalesRevenue: orders
        .filter(o => o.status !== 'cancelled')
        .reduce((sum, o) => sum + (o.total || 0), 0),
      
      avgOrderValue: orders.length > 0 
        ? orders.filter(o => o.status !== 'cancelled').reduce((sum, o) => sum + (o.total || 0), 0) / orders.length 
        : 0
    };
    
    return { success: true, analytics };
  } catch (error) {
    console.error('getAnalytics error:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Finans raporu al
 */
export const getFinancialReport = async (startDate, endDate) => {
  try {
    let ordersQuery = ordersCollection;
    
    if (startDate) {
      ordersQuery = query(ordersQuery, where('createdAt', '>=', startDate));
    }
    if (endDate) {
      ordersQuery = query(ordersQuery, where('createdAt', '<=', endDate));
    }
    
    const snapshot = await getDocs(ordersQuery);
    const orders = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    
    const completedOrders = orders.filter(o => o.status === 'delivered');
    const cancelledOrders = orders.filter(o => o.status === 'cancelled');
    
    const revenue = completedOrders.reduce((sum, o) => sum + (o.total || 0), 0);
    const refunds = cancelledOrders.reduce((sum, o) => sum + (o.total || 0), 0);
    
    // Maliyet hesaplama (gerçek maliyet verisi yoksa tahmini %60)
    const cost = completedOrders.reduce((sum, o) => {
      const orderCost = (o.items || []).reduce((itemSum, item) => {
        return itemSum + (item.price * 0.6 * item.quantity);
      }, 0);
      return sum + orderCost;
    }, 0);
    
    const profit = revenue - cost;
    const margin = revenue > 0 ? ((profit / revenue) * 100).toFixed(2) : 0;
    
    return {
      success: true,
      data: {
        revenue,
        cost,
        profit,
        margin,
        refunds,
        totalOrders: orders.length,
        completedOrders: completedOrders.length,
        cancelledOrders: cancelledOrders.length,
        avgOrderValue: completedOrders.length > 0 ? revenue / completedOrders.length : 0
      }
    };
  } catch (error) {
    console.error('Finans raporu alınamadı:', error);
    return { success: false, error: error.message };
  }
};

export default {
  getAnalytics,
  getFinancialReport
};
